// Null또는 공백인 경우 체크
export const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string' && value.trim() === '') return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && Object.keys(value).length === 0) return true;
    return false;
};

// Null이 아닌 경우 체크
export const isNoEmpty = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string' && value.trim() === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
};

// email 체크
export const isEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

// 휴대전화 번호 체크
export const isPhone = (phone) => {
    const regex = /^01[016789]-?\d{3,4}-?\d{4}$/;
    return regex.test(phone);
};

// 유선번호 체크
export const isTel = (tel) => {
    const regex = /^(0\d{1,2})-?\d{3,4}-?\d{4}$/;
    return regex.test(tel);
};

//테이블명 체크
export const getTable = (bbsType, isComment) => {
  const table = {
    GEN: ['TB_CM_BULLETIN', 'TB_CM_BULLETIN_COMMENT'],
    SPC: ['TB_CM_SPECIAL_BULLETIN', 'TB_CM_SPECIAL_BULLETIN_CMT'],
    CRS: ['TB_GN_COURSE_BULLETIN', 'TB_GN_COURSE_BULLETIN_CMT'],
    LEC: ['TB_GN_LECTURE_BULLETIN', 'TB_GN_LECTURE_BULLETIN_CMT'],
  };
  return table[bbsType][isComment ? 1 : 0];
};